import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

import { logger } from '#lib/logger';

@Injectable({
  providedIn: 'root',
})
export class LocalNotificationService {
  private permissionGranted = false;
  private initialized = false;

  constructor(private router: Router) {}

  async init(): Promise<void> {
    if (!Capacitor.isNativePlatform() || this.initialized) {
      return;
    }

    this.initialized = true;

    await LocalNotifications.addListener(
      'localNotificationActionPerformed',
      async (notification) => {
        logger.log(notification, 'LocalNotificationService -> localNotificationActionPerformed');

        const navigatePath = notification.notification.extra?.['navigatePath'];

        if (navigatePath) {
          await this.router.navigateByUrl(navigatePath);
        }
      }
    );
  }

  async requestPermission(): Promise<boolean> {
    if (!Capacitor.isNativePlatform()) {
      return false;
    }

    if (this.permissionGranted) {
      return true;
    }

    let status = await LocalNotifications.checkPermissions();

    if (status.display === 'prompt') {
      status = await LocalNotifications.requestPermissions();
    }

    this.permissionGranted = status.display === 'granted';

    logger.log(this.permissionGranted, 'LocalNotificationService.requestPermission -> granted');

    return this.permissionGranted;
  }

  async notifyBatchComplete(
    completedCount: number,
    failedCount: number,
    navigatePath?: string
  ): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const granted = await this.requestPermission();

    if (!granted) {
      return;
    }

    let body: string;

    if (failedCount > 0) {
      body = `${completedCount} uploaded, ${failedCount} failed.`;
    } else {
      body = `${completedCount} file${completedCount !== 1 ? 's' : ''} uploaded successfully.`;
    }

    await LocalNotifications.schedule({
      notifications: [
        {
          id: Date.now(),
          title: 'Upload Complete',
          body,
          extra: navigatePath ? { navigatePath } : undefined,
        },
      ],
    });
  }
}
